import {
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  DialogActions,
} from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

type ButtonProps = {
  color: string;
  disabled?: boolean;
};

export const Dialog = lib.styled(MuiDialog)`
  .MuiDialogContent-root {
    width: 240px;
    background-color: ${colors.white02};
    padding: 0px;
  }

  .MuiPaper-rounded {
    border-radius: 10px;
  }

`;

export const DialogContent = lib.styled(MuiDialogContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  gap: 10px;

  &.MuiDialogContent-root {
    padding-bottom: 15px;
  }

  span {
    text-align: center;
    font-size: 0.9rem;
    padding: 0 10px 0 10px;
  }
`;

export const ActionButtons = lib.styled(DialogActions)`
    display: flex;
    max-width: 223px;
    background: ${colors.white};
    gap: 25px;
    height: 27px;

    &.MuiDialogActions-root {
      align-items: center;
      justify-content: center!important;
    }
`;

export const Container = lib.styled.div`
    display: flex;
    height: 65px;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px 0 15px;
    background: ${colors.white};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
`;

export const Button = lib.styled.button<ButtonProps>`
    background: transparent;
    border: none;
    font-family: 'Nunito';
    color: ${(props: ButtonProps) =>
      props.color ? props.color : colors.lightBlue13};
    font-weight: bold;
    cursor: pointer;
    
    ${(props: ButtonProps) =>
      props.disabled &&
      `
      color: ${colors.darkGray11};
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;
